import {Component, OnInit} from "@angular/core";
import {Api} from "../shared/api.service";
import {PokeGroup, PokeGroupCollection} from "../shared/api/messagecentrals/imports/api.models";
import * as moment from 'moment';
import {NgbDateStruct} from "@ng-bootstrap/ng-bootstrap";
import {Language} from "../shared/api/languages/api.models";
import {Messagecentral} from "../shared/api/messagecentrals/api.models";
import {ActivatedRoute} from "@angular/router";
import {Utils} from "../shared/utils.service";

@Component({
    selector : 'import-message',
    template: require('./import.component.html'),
    styles: [require('./import.component.scss')]
})

export class ImportMessageComponent implements OnInit {
    public importing: boolean = false;
    public history: PokeGroup[] = [];
    public importData: any;
    public startMinDate: NgbDateStruct;
    public startMaxDate: NgbDateStruct;
    public endMinDate: NgbDateStruct;
    public endMaxDate: NgbDateStruct;

    protected languages: Language[]             = [];
    protected languagesHash: any                = {};
    protected messagecentrals: Messagecentral[] = [];

    constructor(private route: ActivatedRoute, private api: Api, private utils: Utils) {}

    ngOnInit(): void {
        this.languages       = this.route.snapshot.data['languages'];
        this.messagecentrals = this.route.snapshot.data['messagecentrals'];
        this.utils.hash(this.languagesHash, this.languages);
        this.history = [];

        this.resetForm(null);
    }

    startChanges(date: NgbDateStruct) {
        this.endMinDate = date;
    }

    endChanges(date: NgbDateStruct) {
        this.startMaxDate = date;
    }

    changeSource(event: Event) {
        this.refreshHistory();
    }

    refreshHistory() {
        this.api.messagecentrals().imports(this.importData.messagecentralId).collection(1, 1000).subscribe((result: PokeGroupCollection) => {
            this.history = result.result;
        });
    }

    importMessages() {
        this.importing = true;

        this.api.messagecentrals().imports(this.importData.messagecentralId).group(
            moment().set({'year' : this.importData.start.year, 'month' : this.importData.start.month - 1, 'date' : this.importData.start.day}).format('YYYY-MM-DD'),
            moment().set({'year' : this.importData.end.year, 'month' : this.importData.end.month - 1, 'date' : this.importData.end.day}).format('YYYY-MM-DD'),
            this.importData.amount
        ).subscribe((pokegroup: PokeGroup) => {
            this.history.unshift(pokegroup);
            this.resetForm(this.importData.messagecentralId);
        });
    }

    private resetForm(messagecentralId?: number) {
        var yesterday = moment().subtract(1, 'days');

        this.importData = {
            start            : null,
            end              : null,
            amount           : 100,
            messagecentralId : messagecentralId
        };

        this.startMinDate = {
            day : 1,
            month: 1,
            year: 2012
        };

        this.startMaxDate = {
            day : yesterday.date() ,
            month: yesterday.month() + 1,
            year: yesterday.year()
        };

        this.endMinDate = {
            day : 1,
            month: 1,
            year: 2012
        };

        this.endMaxDate = {
            day : yesterday.date() ,
            month: yesterday.month() + 1,
            year: yesterday.year()
        };
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/messages/import.component.ts